<template>
  <div>
    <Drawer :drawer="drawer" :withHeader="false" :size="size" @close="close">
      <div v-loading="loading" class="view">
        <div v-if="!showTrack && !showIsf && !showOrderDetail">
          <div class="tag">
            <el-tabs v-model="active" type="card" @tab-click="handleClick">
              <el-tab-pane label="基本信息" name="0"></el-tab-pane>
              <el-tab-pane
                v-if="mblDetail.pickUpType"
                label="货物信息"
                name="2"
              ></el-tab-pane>
              <el-tab-pane
                v-if="!billType"
                label="船司轨迹"
                name="3"
              ></el-tab-pane>
              <el-tab-pane
                v-if="mblDetail.clearenceType"
                label="清关轨迹"
                name="4"
              ></el-tab-pane>
              <el-tab-pane
                label="跟进人信息"
                name="5"
              ></el-tab-pane>
              <el-tab-pane
                :label="'邮件记录('+emailList.length+')'"
                name="6"
              ></el-tab-pane>
              <el-tab-pane
                label="提单备注"
                name="7"
              ></el-tab-pane>
            </el-tabs>
            <i class="el-icon-close closeIcon" @click="close" />
          </div>
          <div v-if="active === '0'" class="panel panelActive1">
            <div class="panel2">
              <div class="panel-title">
                <span>
                  <svg-icon
                    iconClass="panelTitle-icon"
                    className="icon"
                    :style="{ 'font-size': 20 }"
                  />
                  基本信息
                  <span class="label-mark" style="margin:0 10px; display: inline-block;    background: #e9ecf3;padding: 0 5px">提单号</span>
                  <span class="label-info">{{ mblDetail.mblNo }}</span>
                  <span class="label-mark" style="margin:0 10px; display: inline-block;    background: #e9ecf3;padding: 0 5px">件数</span>
                  <span class="label-info">{{ mblDetail.qty }}</span>
                  <span class="label-mark" style="margin:0 10px; display: inline-block;    background: #e9ecf3;padding: 0 5px">方数</span>
                  <span class="label-info">{{ mblDetail.weightCbm }}</span>
                  <span class="label-mark" style="margin:0 10px; display: inline-block;    background: #e9ecf3;padding: 0 5px">重量</span>
                  <span class="label-info">{{ mblDetail.weightKgs }}</span>
                </span>
                <div
                  class="opt-btn"
                  @click="viewDetails('track')"
                >
                  <img src="@/assets/images/bill/track.png" />
                  提单轨迹
                </div>
              </div>
              <el-row>
                <el-col :span="8">
                  <div class="field">
                    <label>{{ billType ? "航空公司" : "船公司" }}</label>
                    <p>{{ mblDetail.transportName }}</p>
                  </div>
                </el-col>
                <!-- <el-col :span="8">
                  <div class="field">
                    <label>主单号</label>
                    <p v-tooltip="155">{{ mblDetail.mblNo }}</p>
                  </div>
                </el-col> -->
                <el-col :span="8">
                  <div class="field">
                    <label>目的国家</label>
                    <p>{{ mblDetail.countryCode }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>ETD</label>
                    <p>{{ mblDetail.etd | dateFilete }}</p>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="8">
                  <div class="field">
                    <label>ETA</label>
                    <p>{{ mblDetail.eta | dateFilete }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>ATD</label>
                    <p>{{ mblDetail.atd | dateFilete }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>ATA</label>
                    <p>{{ mblDetail.ata | dateFilete }}</p>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="8">
                  <div class="field">
                    <label>{{ billType ? "始发机场" : "始发地" }}</label>
                    <p v-tooltip="155">{{ mblDetail.originHarborName }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>{{ billType ? "目的机场" : "目的地" }}</label>
                    <p v-tooltip="155">{{ mblDetail.destinationHarborName }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>清关方式</label>
                    <p style="color:  rgb(18,88,188)">
                      <span
                        class="type"
                        style="background: rgba(35, 149, 243, 0.1)"
                      >
                        {{ mblDetail.clearenceType ? "平台清" : "自清" }}
                      </span>
                      <span v-if="mblDetail.clearenceType">{{ mblDetail?.clearence?.clearenceSupplierName }}</span>
                    </p>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="8">
                  <div class="field">
                    <label>提货方式</label>
                    <p style="color: #9d67fe">
                      <span
                        class="type"
                        style="background: rgba(157, 103, 254, 0.1)"
                      >
                        {{
                          mblDetail.pickUpType
                            ? mblDetail.pickUpType === 1
                              ? "直送"
                              : "回仓"
                            : "自提"
                        }}
                      </span>
                      <span v-if="mblDetail.pickUpType">{{ mblDetail?.pickUp?.pickUpSupplierName }}</span>
                      <el-popover
                        v-if=" mblDetail.pickUpType === 1 && (mblDetail.pickUp.sendWayItems[0].type === 2 || mblDetail.pickUp.sendWayItems[0].type === 3 || mblDetail.pickUp.sendWayItems[0].type === 102)"
                        placement="bottom-end"
                        width="474"
                        trigger="hover"
                      >
                        <div class="address-content">
                          <p class="address-lable">直送地址</p>
                          <div class="address-value">
                            <p>
                              <span class="lable">公司名</span>
                              <span class="value">{{ mblDetail.pickUp.sendWayItems[0]?.companyName || mblDetail.pickUp.sendWayItems[0]?.name }}</span>
                              <span style="margin-left: 20px" class="lable">邮编</span>
                              <span class="value">{{ mblDetail.pickUp.sendWayItems[0]?.postalCode }}</span>
                            </p>
                            <p style="margin-top: 5px">
                              <span class="lable">电话</span>
                              <span class="value">{{ mblDetail.pickUp.sendWayItems[0]?.phone }}</span>
                              <span style="margin-left: 20px" class="lable">邮箱</span>
                              <span class="value">{{ mblDetail.pickUp.sendWayItems[0]?.email }}</span>
                            </p>
                            <p class="address-detail" style="margin-top: 5px">
                              <span class="lable">地址</span>
                              <span class="value">{{ mblDetail.pickUp.sendWayItems[0]?.addressLine1 }}{{ mblDetail.pickUp.sendWayItems[0]?.addressLine2 }}</span>
                            </p>
                          </div>
                        </div>
                        <img slot="reference" style="vertical-align: sub" src="@/assets/images/bill/address.png" />
                      </el-popover>
                    </p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>提单类型</label>
                    <p>
                      {{
                        mblDetail.classification
                          ? "分单"
                          : "直单"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div v-if="userInfo?.typeEnum !== 102" class="field">
                    <label>提单文件</label>
                    <p>
                      <span class="check_file" @click="checkBillFile">
                        <i class="el-icon-search"></i>查看提单文件
                      </span>
                    </p>
                  </div>
                </el-col>
                <!-- <el-col :span="8">
                  <div class="field">
                    <label>拆柜供应商</label>
                    <p style="color:  rgb(18,88,188)">
                      <span>{{ rowData?.supplierUnstuffingName }}</span>
                    </p>
                  </div>
                </el-col> -->
                <!-- </el-row>
              <el-row> -->
                <el-col :span="8">
                  <div class="field">
                    <label>清关状态</label>
                    <p>
                      <span class="bill-status">
                        <!-- {{ config.clearenceStatusOptions.find(
                          (a) => a.value === mblDetail.clearenceStatus
                        )?.label }} -->
                        {{ mblDetail.clearenceStatusName }}
                      </span>
                    </p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>提货状态</label>
                    <p>
                      <span class="bill-status">
                        <!-- {{ config.departureStatusOptions.find(
                          (a) => a.value === mblDetail.pickUpSplitDeliveryStatus
                        )?.label }} -->
                        {{ mblDetail.pickUpSplitDeliveryStatusName }}
                      </span>
                    </p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>确认时间</label>
                    <p>{{ mblDetail.entryDate | dateFilete }}</p>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col v-if="mblDetail.clearenceType && mblDetail.clearence?.isf?.amsscac" :span="8">
                  <div class="field">
                    <label>ISF信息</label>
                    <p v-if="userInfo?.typeEnum !== 102"><el-button size="small" type="text" @click="viewDetails('isf')">详情</el-button></p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>接收DO邮箱</label>
                    <p v-tooltip="190">{{ mblDetail?.clearence?.receivedDoEmail }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>接收DO公司名称</label>
                    <p v-tooltip="190">{{ mblDetail?.clearence?.receivedDoCompany }}</p>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="8">
                  <div class="field">
                    <label>原产国</label>
                    <p v-tooltip="190">{{ mblDetail?.originCountry }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>是否申报ISF</label>
                    <p v-tooltip="190">{{ mblDetail?.isDeclareISF ? '是' : '否' }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>卸货港</label>
                    <p v-tooltip="190">{{ mblDetail?.dischargeHarbor }}</p>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="8">
                  <div class="field">
                    <label>卸货港日期</label>
                    <p v-tooltip="190">{{ mblDetail?.dischargeHarborDate }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>DO</label>
                    <p>{{ mblDetail?.clearence?.doDate | dateFilete }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>AN</label>
                    <p>{{ mblDetail?.clearence?.anDate | dateFilete }}</p>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="8">
                  <div class="field">
                    <label>清关模式</label>
                    <p>{{ mblDetail?.clearanceModeExt }}</p>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="24">
                  <div class="field">
                    <label>发货人/Shipper</label>
                    <div class="field-content">
                      <div class="field-c_top">
                        <div
                          v-if="shipperNameOptions?.name"
                          class="field3"
                        >
                          <span>公司名</span>
                          <span>{{ shipperNameOptions?.name }}</span>
                        </div>
                      </div>
                      <div class="field-c_top">
                        <div
                          v-if="shipperNameOptions?.taxNo && userInfo?.typeEnum !== 102"
                          class="field3"
                        >
                          <span>税号</span>
                          <span>{{ shipperNameOptions?.taxNo }}</span>
                        </div>
                      </div>
                      <div class="field-c_bottom">
                        <p>
                          {{ shipperNameOptions?.address | formatStatusAddress }}
                          {{ shipperNameOptions?.cityAddress | formatStatusAddress }}
                          {{ shipperNameOptions?.provinceEnName | formatStatusAddress }}
                          {{ shipperNameOptions?.countryName | formatStatusAddress }}
                          <strong>{{ shipperNameOptions?.postcode ? shipperNameOptions?.postcode : '' }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="24">
                  <div class="field">
                    <label>收货人/Consignee</label>
                    <div class="field-content">
                      <div class="field-c_top">
                        <div
                          v-if="consigneeNameOptions?.name"
                          class="field3"
                        >
                          <span>公司名</span>
                          <span>{{ consigneeNameOptions?.name }}</span>
                        </div>
                      </div>
                      <div class="field-c_top">
                        <div
                          v-if="shipperNameOptions?.taxNo && userInfo?.typeEnum !== 102"
                          class="field3"
                        >
                          <span>税号</span>
                          <span>{{ shipperNameOptions?.taxNo }}</span>
                        </div>
                      </div>
                      <div class="field-c_bottom">
                        <p>
                          {{ consigneeNameOptions?.address | formatStatusAddress }}
                          {{ consigneeNameOptions?.cityAddress | formatStatusAddress }}
                          {{ consigneeNameOptions?.provinceEnName | formatStatusAddress }}
                          {{ consigneeNameOptions?.countryName | formatStatusAddress }}
                          <strong>{{ consigneeNameOptions?.postcode ? consigneeNameOptions?.postcode : '' }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="24">
                  <div class="field">
                    <label>通知方/Notify party</label>
                    <div class="field-content">
                      <div class="field-c_top">
                        <div
                          v-if="notifyPartyOptions?.name"
                          class="field3"
                        >
                          <span>公司名</span>
                          <span>{{ notifyPartyOptions?.name }}</span>
                        </div>
                      </div>
                      <div class="field-c_top">
                        <div
                          v-if="notifyPartyOptions?.taxNo && userInfo?.typeEnum !== 102"
                          class="field3"
                        >
                          <span>税号</span>
                          <span>{{ notifyPartyOptions?.taxNo }}</span>
                        </div>
                      </div>
                      <div class="field-c_bottom">
                        <p>
                          {{ notifyPartyOptions?.address | formatStatusAddress }}
                          {{ notifyPartyOptions?.cityAddress | formatStatusAddress }}
                          {{ notifyPartyOptions?.provinceEnName | formatStatusAddress }}
                          {{ notifyPartyOptions?.countryName | formatStatusAddress }}
                          <strong>{{ notifyPartyOptions?.postcode ? notifyPartyOptions?.postcode : '' }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="24">
                  <div class="field">
                    <label>制造商/Manufacturer</label>
                    <div class="field-content">
                      <div class="field-c_top">
                        <div
                          v-if="manufacturerOptions?.name"
                          class="field3"
                        >
                          <span>公司名</span>
                          <span>{{ manufacturerOptions?.name }}</span>
                        </div>
                      </div>
                      <div class="field-c_top">
                        <div
                          v-if="manufacturerOptions?.taxNo && userInfo?.typeEnum !== 102"
                          class="field3"
                        >
                          <span>税号</span>
                          <span>{{ manufacturerOptions?.taxNo }}</span>
                        </div>
                      </div>
                      <div class="field-c_bottom">
                        <p>
                          {{ manufacturerOptions?.address | formatStatusAddress }}
                          {{ manufacturerOptions?.cityAddress | formatStatusAddress }}
                          {{ manufacturerOptions?.provinceEnName | formatStatusAddress }}
                          {{ manufacturerOptions?.countryName | formatStatusAddress }}
                          <strong>{{ manufacturerOptions?.postcode ? manufacturerOptions?.postcode : '' }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="24">
                  <div class="field">
                    <label>进口商/Importer</label>
                    <div class="field-content">
                      <div class="field-c_top">
                        <div
                          v-if="importerOptions?.name"
                          class="field3"
                        >
                          <span>公司名</span>
                          <span>{{ importerOptions?.name }}</span>
                        </div>
                      </div>
                      <div class="field-c_top">
                        <div
                          v-if="importerOptions?.taxNumber && userInfo?.typeEnum !== 102"
                          class="field3"
                        >
                          <span>税号</span>
                          <span>{{ importerOptions?.taxNumber }}</span>
                        </div>
                      </div>
                      <div class="field-c_bottom">
                        <p>
                          {{ importerOptions?.address | formatStatusAddress }}
                          {{ importerOptions?.cityAddress | formatStatusAddress }}
                          {{ importerOptions?.provinceEnName | formatStatusAddress }}
                          {{ importerOptions?.countryName | formatStatusAddress }}
                          <strong>{{ importerOptions?.postcode ? importerOptions?.postcode : '' }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
                <!-- </el-row>
              <el-row> -->
                <el-col :span="24">
                  <div class="field">
                    <label style="text-align: center">最终收货人<br />Ultimate consignee</label>
                    <div class="field-content">
                      <div class="field-c_top">
                        <div
                          v-if="ultimateConsigneeOptions?.name"
                          class="field3"
                        >
                          <span>公司名</span>
                          <span>{{ ultimateConsigneeOptions?.name }}</span>
                        </div>
                      </div>
                      <div class="field-c_top">
                        <div
                          v-if="ultimateConsigneeOptions?.taxNo && userInfo?.typeEnum !== 102"
                          class="field3"
                        >
                          <span>税号</span>
                          <span>{{ ultimateConsigneeOptions?.taxNo }}</span>
                        </div>
                      </div>
                      <div class="field-c_bottom">
                        <p>
                          {{ ultimateConsigneeOptions?.address | formatStatusAddress }}
                          {{ ultimateConsigneeOptions?.cityAddress | formatStatusAddress }}
                          {{ ultimateConsigneeOptions?.provinceEnName | formatStatusAddress }}
                          {{ ultimateConsigneeOptions?.countryName | formatStatusAddress }}
                          <strong>{{ ultimateConsigneeOptions?.postcode ? ultimateConsigneeOptions?.postcode : '' }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="panel2">
              <div class="panel-title">
                <div>
                  <svg-icon
                    iconClass="panelTitle-icon"
                    className="icon"
                    :style="{ 'font-size': 20 }"
                  />
                  查验信息
                </div>
              </div>
              <el-row>
                <el-col :span="8">
                  <div class="field">
                    <label>放行时间</label>
                    <p>{{ mblDetail?.clearence?.releaseDate }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>是否查验</label>
                    <p>{{ mblDetail?.clearence?.isHold ? '是' : '否' }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <label>查验原因</label>
                    <p v-tooltip="510">{{ mblDetail?.clearence?.holdReason }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
            <template v-if="!billType">
              <div v-for="(item, $index) in mblDetail.container" :key="$index" class="panel2">
                <div class="panel-title">
                  <div class="panel-titleInfo">
                    <div>
                      <svg-icon
                        iconClass="panelTitle-icon"
                        className="icon"
                        :style="{ 'font-size': 20 }"
                      />
                      柜子信息
                    </div>
                    <div v-show="!openInfo" class="roughly">
                      <div class="roughly-item">
                        <span class="flex_c_c">柜号</span>
                        <span>{{ item.containerNumber }}</span>
                      </div>
                      <div class="roughly-item">
                        <span class="flex_c_c">柜型</span>
                        <span>{{ item.containertype }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="open flex_c_c" @click="openInfo = !openInfo">
                    <img :src="require(`@/assets/images/bill/${openInfo ? 'packUp' : 'open'}.png`)">
                    {{ openInfo ? '收起' : '展开' }}
                  </div>
                </div>
                <div v-show="openInfo">
                  <el-row>
                    <el-col :span="8">
                      <div class="field">
                        <label>柜号</label>
                        <p v-tooltip="155">{{ item.containerNumber }}</p>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="field">
                        <label>柜型</label>
                        <p v-tooltip="155">{{ item.containertype }}</p>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="field">
                        <label>船名</label>
                        <p v-tooltip="155">{{ item.vesselName }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <div class="field">
                        <label>船次/航次</label>
                        <p v-tooltip="155">{{ item.voyageNo }}</p>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="field">
                        <label>航线</label>
                        <p v-tooltip="155">{{ item.routeLine }}</p>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="field">
                        <label>封条号</label>
                        <p v-tooltip="155">{{ item.sealNumber }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <div class="field">
                        <label>卸船日期</label>
                        <p>{{ item.dischargeDate | dateFilete }}</p>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="field">
                        <label>可提柜日期</label>
                        <p>{{ item.availableDate | dateFilete }}</p>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="field">
                        <label>还空柜日期</label>
                        <p>{{ item.emptyReturnedDate | dateFilete }}</p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </template>
            <!-- <div class="panel-btn-content">
              <div
                class="panel-btn"
                @click="viewDetails('track')"
              >
                <img src="@/assets/images/bill/track.png" />
                提单轨迹
              </div>
            </div> -->
            <!-- <div v-else-if="mblDetail.clearenceType !== 0 && mblDetail.status === 0 && billType === 0" class="panel-btn" @click="viewDetails('isf')">
              <img src="@/assets/images/bill/isf.png" />
              ISF信息
            </div> -->
          </div>
          <div v-if="active === '2'" class="panel panelActive3">
            <div class="panel2">
              <div class="panel-title">
                <svg-icon
                  iconClass="panelTitle-icon"
                  className="icon"
                  :style="{ 'font-size': 20 }"
                />
                提货信息
              </div>
              <div class="panle-container">
                <el-row>
                  <!-- <el-col :span="12">
                    <div class="field">
                      <label>预约时间</label>
                      <p>{{ mblDetail?.pickUp?.picExpactDate | dateFilete }}</p>
                    </div>
                  </el-col> -->
                  <el-col :span="12">
                    <div class="field">
                      <label>预约提货时间</label>
                      <p>
                        {{ mblDetail?.pickUp?.picExpactPickUpDate | dateFilete }}
                      </p>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="field">
                      <label>提货时间</label>
                      <p>{{ mblDetail?.pickUp?.picPickUpDate | dateFilete }}</p>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="field">
                      <label>状态</label>
                      <p>
                        <span class="status">{{
                        config.billShipSubtabOptions[mblDetail.status]?.find(
                          (a) => a.value == mblDetail.subStatus
                        )?.label
                        }}</span>
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <!-- <div class="panel2">
              <div class="panel-title">
                <svg-icon
                  iconClass="panelTitle-icon"
                  className="icon"
                  :style="{ 'font-size': 20 }"
                />
                到仓信息
              </div>
              <div class="panle-container">
                <el-row>
                  <el-col :span="12">
                    <div class="field">
                      <label>到仓时间</label>
                      <p>
                        {{ mblDetail?.pickUp?.picArrivedDate | dateFilete }}
                      </p>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="field">
                      <label>首次扫描时间</label>
                      <p>
                        {{
                          mblDetail?.pickUp?.picFirstArrivedScanDate
                            | dateFilete
                        }}
                      </p>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="field">
                      <label>到仓件数</label>
                      <p>
                        <span class="markbox">
                          <span class="mark-label green">已到</span>
                          <span class="mark-info">{{ mblDetail?.pickUp?.arrivedQty }}</span>
                        </span>
                        <span class="markbox">
                          <span class="mark-label red">未到</span>
                          <span class="mark-info">{{ mblDetail?.pickUp?.notArrivedQty }}</span>
                        </span>
                      </p>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="field">
                      <label>扫描完成时间</label>
                      <p>
                        {{
                          mblDetail?.pickUp?.picLastArrivedScanDate | dateFilete
                        }}
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="panel2">
              <div class="panel-title">
                <svg-icon
                  iconClass="panelTitle-icon"
                  className="icon"
                  :style="{ 'font-size': 20 }"
                />
                出仓信息
              </div>
              <div class="panle-container">
                <el-row>
                  <el-col :span="12">
                    <div class="field">
                      <label>出仓板数</label>
                      <p>{{ mblDetail?.pickUp?.departureCbm }}</p>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="field">
                      <label>首次扫描时间</label>
                      <p>
                        {{
                          mblDetail?.pickUp?.picFirstDepaturedScanDate
                            | dateFilete
                        }}
                      </p>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="field">
                      <label>出仓件数</label>
                      <p>
                        <span class="markbox">
                          <span class="mark-label green">已出</span>
                          <span class="mark-info">{{ mblDetail?.pickUp?.depaturedQty }}</span>
                        </span>
                        <span class="markbox">
                          <span class="mark-label red">未出</span>
                          <span class="mark-info">{{ mblDetail?.pickUp?.notDepaturedQty }}</span>
                        </span>
                      </p>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="field">
                      <label>扫描完成时间</label>
                      <p>
                        {{
                          mblDetail?.pickUp?.picLastDepaturedcanDate
                            | dateFilete
                        }}
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div> -->
            <div>
              <div class="panel-title">
                <svg-icon
                  iconClass="panelTitle-icon"
                  className="icon"
                  :style="{ 'font-size': 20 }"
                />
                派送方式
              </div>
              <div class="panle-container panel3">
                <BaseTable
                  :height="height - 550"
                  :tableData="tableData1"
                  :isPager="false"
                  :border="true"
                >
                  <template slot="opt" slot-scope="row">
                    <div class="table-opt">
                      <el-popover placement="left" width="300" trigger="hover">
                        <div class="view-detail">
                          <div
                            v-for="(item, $index) in row.scope.eventItems"
                            :key="$index"
                            class="eventItems"
                          >
                            <p>{{ item.eventDate }}</p>
                            <p>{{ item.title }} {{ item.description }}</p>
                          </div>
                        </div>
                        <img
                          slot="reference"
                          style="cursor: pointer"
                          src="@/assets/images/bill/detail.png"
                        />
                      </el-popover>
                    </div>
                  </template>
                  <template slot="remarks" slot-scope="row">
                    <el-popover
                      v-if="row.scope.remarks"
                      placement="bottom-end"
                      width="440"
                      trigger="hover">
                      <div class="remarks-box">
                        <div class="remarks-header">
                          <span>备注内容</span>
                          <span @click="handleCopy(row.scope.remarks)"><img src="@/assets/images/order/copy3.png">复制</span>
                        </div>
                        <div class="remarks-body">
                          {{ row.scope.remarks }}
                        </div>
                      </div>
                      <img slot="reference" style="cursor: pointer;" src="@/assets/images/bill/detail.png">
                    </el-popover>
                    <span v-else>--</span>
                  </template>
                  <template slot="arrivalQty" slot-scope="row">
                    <p>
                      <span class="lable">
                        {{ row.scope.arrivalQty || 0 }}
                        <span class="sufix">件</span>
                      </span>
                    </p>
                    <p style="margin-top: 5px">
                      <span class="lable">
                        {{ row.scope.square || 0 }}
                        <span class="sufix">CBM</span>
                      </span>
                    </p>
                    <p style="margin-top: 5px">
                      <span class="lable">
                        {{ row.scope.weight || 0 }}
                        <span class="sufix">KG</span>
                      </span>
                    </p>
                  </template>
                  <template slot="departureQty" slot-scope="row">
                    <p>
                      <span class="lable">
                        {{ row.scope.departureQty || 0 }}
                        <span class="sufix">件</span>
                      </span>
                    </p>
                    <p style="margin-top: 5px">
                      <span class="lable">
                        {{ row.scope.departureCbm || 0 }}
                        <span class="sufix">板</span>
                      </span>
                    </p>
                    <p style="margin-top: 5px">
                      <span class="lable">
                        {{ row.scope.weight || 0 }}
                        <span class="sufix">KG</span>
                      </span>
                    </p>
                  </template>
                  <template slot="typeName" slot-scope="row">
                    <div v-if="row.scope.estimatedDeliveryTime" class="estimatedDeliveryTime flex_c_c">
                      预计送仓日期:{{ row.scope.estimatedDeliveryTime.slice(0, row.scope.estimatedDeliveryTime.length - 9) }}
                    </div>
                    <div class="typeName">
                      {{ row.scope.code ? `${row.scope.typeName}-${row.scope.code}` : row.scope.typeName }}
                      <el-popover
                        v-if=" (mblDetail.pickUpType === 1 || mblDetail.pickUpType === 2) && (row.scope.type === 2 || row.scope.type === 3 || row.scope.type === 102)"
                        placement="bottom-end"
                        width="474"
                        trigger="hover"
                      >
                        <div class="address-content">
                          <p class="address-lable">直送地址</p>
                          <div class="address-value">
                            <p>
                              <span class="lable">公司名</span>
                              <span class="value">{{ row.scope?.companyName || row.scope?.attentionName }}</span>
                              <span style="margin-left: 20px" class="lable">仓库编码</span>
                              <span class="value">{{ row.scope?.code }}</span>
                              <span style="margin-left: 20px" class="lable">邮编</span>
                              <span class="value">{{ row.scope?.postalCode }}</span>
                            </p>
                            <p style="margin-top: 5px">
                              <span class="lable">电话</span>
                              <span class="value">{{ row.scope?.phone }}</span>
                              <span style="margin-left: 20px" class="lable">邮箱</span>
                              <span class="value">{{ row.scope?.email }}</span>
                            </p>
                            <p class="address-detail" style="margin-top: 5px">
                              <span class="lable">地址</span>
                              <span class="value">{{ row.scope?.addressLine1 }}{{ row.scope?.addressLine2 }}</span>
                            </p>
                          </div>
                        </div>
                        <img slot="reference" style="vertical-align: sub" src="@/assets/images/bill/address3.png" />
                      </el-popover>
                    </div>
                  </template>
                </BaseTable>
              </div>
            </div>
          </div>
          <div v-if="active === '3'" class="panel panelActive4">
            <el-row>
              <el-col :span="6">
                <div class="field">
                  <label>提单号</label>
                  <p>{{ containerEvents.mblNo }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="field">
                  <label>柜号</label>
                  <p>{{ containerEvents.containerNumber }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="field">
                  <label>ETD-ETA</label>
                  <p>{{ containerEvents.etd | dateFilete }}-{{ containerEvents.eta | dateFilete }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="field">
                  <label>ATD-ATA</label>
                  <p>{{ containerEvents.atd | dateFilete }}-{{ containerEvents.ata | dateFilete }}</p>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <div class="field">
                  <label>提柜日期</label>
                  <p>{{ containerEvents.gateOutDate | dateFilete }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="field">
                  <label>还空日期</label>
                  <p>{{ containerEvents.emptyReturnDate | dateFilete }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="field">
                  <label>轨迹来源</label>
                  <p>{{ mblDetail?.terminalSupplierName }}</p>
                </div>
              </el-col>
            </el-row>
            <BaseTable
              style="margin-top: 20px;"
              :height="height - 238"
              :tableData="tableData6"
              :isPager="false"
              :border="true"
            >
            </BaseTable>
            <div class="panel-btn-content">
              <div
                class="panel-btn"
                style="      background:  rgb(18,88,188);color: #ffffff;"
                @click="reloadshipPart"
              >
                <img src="@/assets/images/bill/reload.png" />
                刷新
              </div>
            </div>
          </div>
          <div v-if="active === '4'" class="panel panelActive4">
            <el-row style="margin-bottom: 10px;">
              <el-col :span="8">
                <div class="field">
                  <label style="width: auto;padding: 0 10px">Manifested Port of Unlading/Import</label>
                  <p>{{ amsOldData.arrivalPortCode }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <label style="width: auto;padding: 0 10px">Departure Port:</label>
                  <p>{{ amsOldData.departurePortCode }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <label style="width: auto;padding: 0 10px">Departure Date:</label>
                  <p>{{ amsOldData.atd | dateFilete }}</p>
                </div>
              </el-col>
            </el-row>
            <div class="ams" style="width: 100%; height: 100%;">
              <div class="amsList">
                <div
                  v-for="(item, $index) in amsData"
                  :key="$index"
                  class="list">
                  <div
                    class="list-top"
                  >
                    <span
                      class="label"
                    >{{ item.blType === 'M' ? '提单号' : '分单号' }}：<span class="value" :style="{'color': !item.isRed ? '#333333' : '#FE453D'}">{{
                      item.number
                    }}</span></span
                    >
                    <span
                      class="label"
                    >类型：<span
                      :class="[
                        'value',
                        item.blType === 'M' ? 'Master' : 'House',
                      ]"
                    >{{ item.blType === "M" ? "Master" : "House" }}</span
                    ></span
                    >
                    <span
                      v-if="!rowData.type"
                      class="label"
                    >ISF On File：<span
                      class="value"
                      :style="{ color: item.isf ? '#333333' : '#FE453D' }"
                    >{{ item.isf ? "YES" : "NO" }}</span
                    ></span
                    >
                    <span
                      class="label"
                    >数量：<span class="value">{{ item.qty }}</span></span
                    >
                    <span
                      v-if="!rowData.type"
                      class="label"
                    >船名：<span class="value">{{
                      item.vesselName
                    }}</span></span
                    >
                    <span
                      v-if="!rowData.type"
                      class="label"
                    >船次：<span class="value">{{
                      item.voyageNumber
                    }}</span></span
                    >
                    <span
                      class="label"
                    >到达日期：<span class="value">{{
                      item.lastRunTime
                    }}</span></span
                    >
                    <span
                      v-if="item.blType !== 'M'"
                      class="label"
                    >[Inbond No:<span class="value">{{
                      item.inBondNumber
                    }}]</span></span
                    >
                  </div>
                  <div class="list-middle">
                    <div v-for="(event, index) in item.truckItems" :key="index">
                      <span class="icon">{{ event.dispositionCode }}<img src="@/assets/images/bill/qun.png" />
                      </span>
                      <span class="desc">
                        {{ event.dispositionDesc }}
                      </span>
                      <span class="quantity">
                        Quantity： {{ event.manifestQuantity }}
                      </span>
                      <span class="quantity">
                        {{ event.eventDate }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-btn-content">
              <!-- <div
                class="panel-btn"
                style="      background:  rgb(18,88,188);color: #ffffff;"
                @click="reloadship"
              >
                <img src="@/assets/images/bill/reload.png" />
                轨迹同步
              </div> -->
              <div
                class="panel-btn"
                style="      background:  rgb(18,88,188);color: #ffffff;"
                @click="reSub"
              >
                <img src="@/assets/images/bill/reload.png" />
                重新订阅
              </div>
            </div>
          </div>
          <div v-if="active === '5'" class="panel panelActive1">
            <div class="panel2">
              <div v-if="!billType" class="panel-title">
                <svg-icon
                  iconClass="panelTitle-icon"
                  className="icon"
                  :style="{ 'font-size': 20 }"
                />
                基本信息
              </div>
              <el-row>
                <el-col :span="24">
                  <div class="field">
                    <label>操作</label>
                    <p>{{ mblHandlers.operator }}</p>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="field">
                    <label>客服</label>
                    <p>{{ mblHandlers.customer }}</p>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="field">
                    <label>财务</label>
                    <p>{{ mblHandlers.financer }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div v-if="active === '6'" class="panel panelActive4 email-record">
            <div class="mbl-info-search">
              <BaseDateCommon v-model="emailForm.contractDate" width="320">
              </BaseDateCommon>
              <div class="group-box">
                <el-input v-model="emailForm.search" placeholder="发件人/主题" class="input-search">
                  <el-button slot="append" icon="el-icon-search" size="small" style="background:none;" @click="getMBLEmail" />
                </el-input>
              </div>
            </div>
            <el-empty v-if="emailList.length==0"></el-empty>
            <div class="mbl-info-section">
              <div v-for="(item,index) in emailList" :key="index" class="mbl-info" @click="openEmailDialog(item)">
                <div class="info-row email-item-title">
                  {{ item.subject }}
                </div>
                <div class="info-row">
                  <span class="info-label">发件人：</span>
                  <span class="info-value">
                    <template v-if="item.sender.address != item.sender.name">{{ item.sender.name }}&lt;</template>{{ item.sender.address }}<template v-if="item.sender.address != item.sender.name">&gt;</template>
                  </span>
                  <span class="info-label ml-20">发送时间：</span>
                  <span class="info-value">{{ item.receivedDate }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">收件人：</span>
                  <span class="info-value">{{ item.recipients.map(e => e.address).join('、') }}</span>
                </div>
                <div v-if="item.cc && item.cc.length" class="info-row">
                  <span class="info-label">抄送：</span>
                  <span class="info-value">{{ item.cc.map(e => e.address).join('、') }}</span>
                </div>
                <div v-if="item.attachments && item.attachments.length" class="info-row attachments-row">
                  <span class="info-label">附件：</span>
                  <div class="attachment-list">
                    <div v-for="(file, idx) in item.attachments" :key="idx" class="attachment-tag" @click.stop="downLoad(file)">
                      <svg-icon v-if="file.fileName.split('.').pop().toLowerCase() == 'pdf'" iconClass="pdf" className="icon"></svg-icon>
                      <svg-icon v-else-if="file.fileName.split('.').pop().toLowerCase() == 'xlsx'" iconClass="xlsx" className="icon"></svg-icon>
                      <i v-else class="el-icon-document" />
                      <span>{{ file.fileName }}</span>
                      <i class="el-icon-download" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div v-if="active === '7'" class="panel panelActive4">
            <BaseTable
              style="margin-top: 20px;"
              :height="height - 200"
              :tableData="{
                ...tableData7,
                columns: mblDetail?.mblRemarks || []
              }"
              :isPager="false"
              :border="true"
            >
            </BaseTable>
          </div>
        </div>
        <div v-if="showTrack || showIsf || showOrderDetail" class="back">
          <div class="title">
            <div class="before" @click="back">
              <img src="@/assets/images/bill/back.png" alt="">
              <span>{{ showOrderDetail ? "返回订单详情" : "返回详情" }}</span>
            </div>
            <div class="current">
              <img src="@/assets/images/bill/arrow.png" alt="">
              <span>{{ (showIsf && 'ISF信息') || (showTrack && '提单轨迹') || (showOrderDetail && '订单详情') }}</span>
            </div>
          </div>
          <i class="el-icon-close closeIcon" @click="close" />
        </div>
        <div v-if="showTrack" class="log-body">
          <div class="track-num">
            提单号：<span class="number">{{ mblDetail.blNo }}</span>
          </div>
          <div class="track-other">
            <div class="country">
              <div class="country-code">
                <span>{{ mblDetail.originHarborName.split('-')[0] }}</span>
                <span>{{ mblDetail.originHarborName.split('-')[1] }}</span>
              </div>
              <img src="@/assets/images/order/guide.png" />
              <div class="country-code">
                <span>{{ mblDetail.destinationHarborName.split('-')[0] }}</span>
                <span>{{ mblDetail.destinationHarborName.split('-')[1] }}</span>
              </div>
            </div>
            <div class="navication flex_c_c">
              当前状态：<span>{{
                config.billShipSubtabOptions[mblDetail.status]?.find(
                  (a) => a.value == mblDetail.subStatus
                )?.label
              }}</span>
            </div>
          </div>
          <div class="track-step">
            <div v-for="(item, index) in trackList" :key="index" class="step-item">
              <div
                :class="['step-title', index === 0 ? 'blue' :
                  item.descriptionCH.indexOf('海关查验') > -1 ||
                  item.statusCode === 'HOLD_SYS' ? 'check' : '']">
                <div class="dot">
                  <div
                    :class="['step-dot', index === 0 ? 'blue-dot'
                      :
                      item.descriptionCH.indexOf('海关查验') > -1 ||
                      item.statusCode === 'HOLD_SYS' ? 'check-dot' : '']"
                  ></div>
                </div>
                <div class="step-time">
                  {{ item.eventDate }}&nbsp;&nbsp;{{ item.location }}
                </div>
              </div>
              <div
                :class="['step-info', index === 0 ? 'blue' :
                  item.descriptionCH.indexOf('海关查验') > -1 ||
                  item.statusCode === 'HOLD_SYS' ? 'check' : '']">
                <span>{{ item.descriptionCH }}</span>
                <template v-if="item.isOpen && item.outboundDetails">
                  <div v-for="(a, i) in item.outboundDetails" :key="i" class="step-detail">
                    <div class="step-detail_item">
                      <span class="detail-label1">派送方式</span>
                      <span class="detail-info">{{ a?.typeName }}</span>
                    </div>
                    <el-row>
                      <el-col :span="10">
                        <div class="step-detail_item">
                          <span class="detail-label1">总件数</span>
                          <span class="detail-info">{{ a?.qty || 0 }}</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="step-detail_item">
                          <span class="detail-label2">ISP</span>
                          <span class="detail-info">{{ a?.ispFile?.uploadDate ? a?.ispFile?.uploadDate : '无' }}</span>
                          <div v-if="a?.ispFile?.fileGuid" class="viewFile flex_c_c" @click="viewFile(a?.ispFile?.fileGuid)">查看</div>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="10">
                        <div class="step-detail_item">
                          <span class="detail-label1">出仓</span>
                          <span class="detail-info">{{ a?.departureQty }}</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="step-detail_item">
                          <span class="detail-label2">POD</span>
                          <span class="detail-info">{{ a?.podFile?.uploadDate ? a?.podFile?.uploadDate : '无' }}</span>
                          <div v-if="a?.podFile?.fileGuid" class="viewFile flex_c_c" @click="viewFile(a?.podFile?.fileGuid)">查看</div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </template>
              </div>
              <div v-if="index !== trackList.length - 1" :class="['step-line', , index === 0 ? 'blue-line' : '']"></div>
              <i
                v-if="item.outboundDetails && item.outboundDetails.length"
                :class="[item.isOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down', 'arrow']"
                :title="item.isOpen ? '收起' : '展开'"
                @click="isOepn(index)"
              ></i>
            </div>
          </div>
        </div>
        <div v-if="showIsf" class="log-body">
          <div class="isf_info">
            <div class="row-item">
              <div class="item-label">OnBoard Date</div>
              <div class="item-data">
                {{ mblDetail?.clearence?.isf?.onBoardDate | dateFilete }}
              </div>
            </div>
            <div class="row-item">
              <div class="item-label">AMS SCAC</div>
              <div class="item-data">{{ mblDetail?.clearence?.isf?.amsscac }}</div>
            </div>
            <div class="row-item">
              <div class="item-label">AMS No.</div>
              <div class="item-data">{{ mblDetail?.clearence?.isf?.amsblNumber }}</div>
            </div>
            <div class="row-item">
              <div class="item-label">Importer Bond Type</div>
              <div class="item-data">{{ config.bondTypeOptions.find(
                (a) => a.value === mblDetail?.clearence?.isf?.bondType
              )?.label }}</div>
            </div>
            <div class="row-item">
              <div class="item-label">Bill Number Type</div>
              <div class="item-data">{{ mblDetail?.clearence?.isf?.classification ? '分单' : '直单' }}</div>
            </div>
            <div v-for="(item, $index) in addressRowArr" :key="$index" class="row-item">
              <div class="item-label">{{ item.label1 }}<br>{{ item.nameCH }}</div>
              <div class="address">
                <div v-if="item.label1 !== 'Importer'" class="conpanyName">
                  <span>公司名</span>
                  <span>{{ mblDetail?.clearence?.isf?.[item.label2+ 'Address']?.name }}</span>
                </div>
                <div v-else style="display: flex;">
                  <div class="conpanyName">
                    <span>公司名</span>
                    <span>{{ mblDetail?.clearence?.isf?.[item.label2+ 'Address']?.name }}</span>
                  </div>
                  <div class="conpanyName">
                    <span>EIN</span>
                    <span>{{ mblDetail?.clearence?.isf?.importerEIN }}</span>
                  </div>
                </div>
                <p v-if="item.label1 === 'Importer'">
                  {{
                    mblDetail?.clearence?.isf[item.label2 + 'Address']?.importer?.address | formatStatusAddress
                  }}
                  {{ mblDetail?.clearence?.isf[item.label2 + 'Address']?.cityAddress | formatStatusAddress }}
                  {{ mblDetail?.clearence?.isf[item.label2 + 'Address']?.provinceNameEN | formatStatusAddress }}
                  {{
                    mblDetail?.clearence?.isf[item.label2 + 'Address']?.countryCode | formatStatusAddress
                  }}
                  <strong>{{
                    mblDetail?.clearence?.isf[item.label2 + 'Address']?.importer?.postalCode
                      ? mblDetail?.clearence?.isf[item.label2 + 'Address']?.importer?.postalCode
                      : ""
                  }}</strong>
                </p>
                <p v-else>
                  {{
                    mblDetail?.clearence?.isf[item.label2 + 'Address']?.scin?.address | formatStatusAddress
                  }}
                  {{ mblDetail?.clearence?.isf[item.label2 + 'Address']?.cityAddress | formatStatusAddress }}
                  {{ mblDetail?.clearence?.isf[item.label2 + 'Address']?.provinceNameEN | formatStatusAddress }}
                  {{
                    mblDetail?.clearence?.isf[item.label2 + 'Address']?.countryCode | formatStatusAddress
                  }}
                  <strong>{{
                    mblDetail?.clearence?.isf[item.label2 + 'Address']?.scin?.postalCode
                      ? mblDetail?.clearence?.isf[item.label2 + 'Address']?.scin?.postalCode
                      : ""
                  }}</strong>
                </p>
                <!-- <p>
                  {{
                    addressDetail[item.label2 + 'Address']?.addressLine1 | formatStatusAddress
                  }}
                  {{
                    addressDetail[item.label2 + 'Address']?.addressLine2 | formatStatusAddress
                  }}
                  {{ addressDetail[item.label2 + 'Address']?.city | formatStatusAddress }}
                  {{ addressDetail[item.label2 + 'Address']?.state | formatStatusAddress }}
                  {{
                    addressDetail[item.label2 + 'Address']?.countryCode | formatStatusAddress
                  }}
                  <strong>{{
                    addressDetail[item.label2 + 'Address']?.postalCode
                        ? addressDetail[item.label2 + 'Address']?.postalCode
                        : ""
                  }}</strong>
                </p> -->
              </div>
            </div>
          </div>
          <div class="panle-container">
            <div class="table-header">+HS CODE列表</div>
            <BaseTable
              height="133"
              :tableData="tableData3"
              :isPager="false"
              :border="true"
            ></BaseTable>
          </div>
        </div>
      </div>
    </Drawer>
    <UploadAttachmentDialog
      :dialogVisible="dialogVisible"
      :diaLogType="1"
      :rowData="rowData"
      @close="dialogVisible = false"
    ></UploadAttachmentDialog>

    <EmailDetailDrawer :email="emailDetail.currEmail" :visible="emailDetail.visible" @close="closeEmailDialog" />
  </div>
</template>

<script>
const Drawer = () => import('@/components/drawer/Drawer')
import { Empty } from 'element-ui'
import { getMBLEmail, downLoadEmailFile } from '@/api/email'
const BaseDateCommon = () => import('@/components/base/BaseDateCommon.vue')
const BaseTable = () => import('@/components/table/BaseTable')
import UploadAttachmentDialog from './UploadAttachmentDialog.vue'
import EmailDetailDrawer from './EmailDetailDrawer.vue'
import { getMBLDetail, getOrderDetailPages, getMBLTrackList, syncAbiTrack } from '@/api/bill'
import {
  // trackDetail,
  getOrderDetail,
  getOrderDimensionPageList,
  getOrderProductPageList
} from '@/api/fee'
import {
  // catchContainerEvents,
  eFreightContainerEvents,
  iTraceTerminal,
  reSubscribeClearanceTrack,
  // AMSQuery,
  // manualRefreshContainerEvents,
  abiquery
} from '@/api/basic'
import config from '@/utils/config'
import { getRouteByCode, derive } from '@/utils/common'
import { mapGetters } from 'vuex'
export default {
  components: { Drawer, BaseTable, UploadAttachmentDialog, [Empty.name]: Empty, BaseDateCommon, EmailDetailDrawer },
  filters: {
    dateFilete: function(date) {
      if (date) {
        const newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
        return newDate[0]
      } else {
        return ''
      }
    },
    formatStatus: function(value) {
      if (value || value === 0) {
        const item = config.orderStatusOptions.find(
          (a) => parseInt(a.value, 10) === value
        )
        return item.label
      } else {
        return ''
      }
    },
    formatType: function(value) {
      if (value) {
        const arr = [
          '私仓',
          '亚马逊仓',
          '发货/件方',
          '收货/件方',
          '进口商',
          '买家',
          '卖家',
          '制造商',
          '拼货方',
          '货物送达方',
          '装货地',
          '订单收件地址'
        ]
        return arr.find((a, i) => i === value)
      } else {
        return ''
      }
    },
    formatStatusAddress(val) {
      return val ? val + ',' : ''
    },
    formatStatusCollect(type, arr) {
      return arr.find(a => a.type === type)?.qty || 0
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    billType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      config,
      active: '0',
      // pager: {
      //   pageIndex: 1,
      //   pageSize: 1000
      // },
      pager2: {
        pageIndex: 1,
        pageSize: 20
      },
      loading: false,
      size: 1340,
      showTrack: false,
      showIsf: false,
      showOrderDetail: false,
      dialogVisible: false,
      tableData1: {
        fileds: [
          {
            filed: 'typeName',
            label: '派送类型',
            width: '',
            isCustom: true
          },
          {
            filed: 'qty',
            label: '件数',
            width: '59'
          },
          {
            filed: 'arrivalQty',
            label: '到仓信息',
            width: '165',
            isCustom: true
          },
          {
            filed: 'departureQty',
            label: '出仓信息',
            width: '165',
            isCustom: true
          },
          {
            filed: 'remarks',
            label: '备注',
            isCustom: true,
            width: '59'
          }
        ],
        columns: [],
        total: 0
      },
      tableData2: {
        fileds: [
          {
            filed: 'referenceNumber',
            label: '客户单号',
            width: '153',
            isCopy: true
          },
          {
            filed: 'masterTrackingNumber',
            label: '主单号',
            width: '153',
            isCopy: true
          },
          {
            filed: 'trackingNumber',
            label: '子单号',
            width: '153',
            isCopy: true
          },
          {
            filed: 'expressSupplier',
            label: '派送方式',
            width: '80'
          },
          {
            filed: 'opt',
            label: '操作',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      tableData3: {
        fileds: [
          {
            filed: 'hsCode',
            label: '海关编码',
            width: '140'
          },
          {
            filed: 'originCountryCode',
            label: '原产地国家二字代码',
            width: '140'
          },
          {
            filed: 'nameEN',
            label: '英文描述'
          }
        ],
        columns: [],
        total: 0
      },
      tableData4: {
        fileds: [
          {
            filed: 'packageNumber',
            label: '包裹编号',
            width: '80'
          },
          {
            filed: 'trackingNumber',
            label: '追踪单号',
            width: '180',
            isCopy: true
          },
          {
            filed: 'agentLength',
            label: '长',
            width: ''
          },
          {
            filed: 'agentWidth',
            label: '宽',
            width: ''
          },
          {
            filed: 'agentHeight',
            label: '高',
            width: ''
          },
          {
            filed: 'agentDimensionUnit',
            label: '尺寸单位',
            width: ''
          },
          {
            filed: 'agentWeight',
            label: '实重',
            width: ''
          },
          {
            filed: 'calculateVolumeWeight',
            label: '材积重',
            width: ''
          },
          {
            filed: 'calculateWeight',
            label: '计费重量',
            width: ''
          },
          {
            filed: 'agentWeightUnit',
            label: '重量单位',
            width: ''
          },
          {
            filed: 'labelRefNo',
            label: '参考号',
            width: '140'
          }
        ],
        columns: [],
        total: 0
      },
      tableData5: {
        fileds: [
          {
            filed: 'nameEN',
            label: '英文品名',
            width: '140'
          },
          {
            filed: 'nameCH',
            label: '中文品名',
            width: '120'
          },
          {
            filed: 'hsCode',
            label: 'HS CODE',
            width: '100'
          },
          {
            filed: 'qty',
            label: '数量',
            width: ''
          },
          {
            filed: 'unitPrice',
            label: '产品价值',
            width: ''
          },
          {
            filed: 'currency',
            label: '币制',
            width: ''
          },
          {
            filed: 'unitWeight',
            label: '产品重量',
            width: ''
          },
          {
            filed: 'weightUnit',
            label: '重量单位',
            width: ''
          },
          {
            filed: 'sku',
            label: 'SKU',
            width: ''
          },
          {
            filed: 'material',
            label: '材质',
            width: ''
          },
          {
            filed: 'usedFor',
            label: '用途',
            width: ''
          },
          {
            filed: 'productURL',
            label: '产品链接',
            width: '',
            isCustom: true
          },
          {
            filed: 'packageUnit',
            label: '计费单位',
            width: ''
          }
        ],
        columns: [],
        total: 0
      },
      tableData6: {
        fileds: [
          {
            filed: 'nodeName',
            label: '节点',
            width: '',
            resizable: true
          },
          {
            filed: 'trackInfo',
            label: '轨迹描述',
            width: '240',
            resizable: true
          },
          {
            filed: 'trackTime',
            label: '轨迹时间',
            width: '',
            formatter: (row) => {
              if (row.trackTime) {
                return row.trackTime.slice(0, row.trackTime.length - 3)
              } else {
                return ''
              }
            },
            resizable: true
          }
        ],
        columns: [],
        total: 0
      },
      tableData7: {
        fileds: [
          {
            filed: 'location',
            label: '地点',
            width: '',
            resizable: true
          },
          {
            filed: 'createdName',
            label: '创建人',
            width: '',
            resizable: true
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '',
            resizable: true
          },
          {
            filed: 'description',
            label: '备注',
            width: '',
            resizable: true
          }
        ],
        columns: [],
        total: 0
      },
      amsData: [],
      mblDetail: {},
      containerEvents: {}, // 船司轨迹
      order: {}, // 订单详情信息
      orderActive: 0,
      trackList: [],
      addressRowArr: [
        { label1: 'Consignee', label2: 'consigneeName', nameCH: '收货人' },
        { label1: 'Importer', label2: 'importerName', nameCH: '进口商' },
        { label1: 'Buyer', label2: 'buyerName', nameCH: '买方' },
        { label1: 'Selling Party', label2: 'sellingName', nameCH: '卖方' },
        { label1: 'Ship To Party', label2: 'shipToPartyName', nameCH: '收货公司' },
        { label1: 'Manufacture', label2: 'manufacturerName', nameCH: '制造商' },
        { label1: 'Consolidator', label2: 'consolidatorName', nameCH: '拼箱地' },
        { label1: 'Container Staffing Location', label2: 'stuffingName', nameCH: '装柜地' }
      ],
      openInfo: true,
      height: 0,
      orderStatusCollect: [],
      orderTypeCollect: [],
      amsOldData: {},
      emailForm: {
        contractDate: [],
        search: ''
      },
      emailList: [],
      emailDetail: {
        currEmail: {},
        visible: false
      }
    }
  },
  computed: {
    ...mapGetters(['addressDropOption', 'addressBookOptions', 'userInfo']),
    shipperNameOptions() {
      const { mblScinList } = this.mblDetail
      const shipperNameOptions = mblScinList?.find(a => a.type === 0)?.scin
      return shipperNameOptions
    },
    consigneeNameOptions() {
      const { mblScinList } = this.mblDetail
      const shipperNameOptions = mblScinList?.find(a => a.type === 1)?.scin
      return shipperNameOptions
    },
    notifyPartyOptions() {
      const { mblScinList } = this.mblDetail
      const shipperNameOptions = mblScinList?.find(a => a.type === 3)?.scin
      return shipperNameOptions
    },
    manufacturerOptions() {
      const { mblScinList } = this.mblDetail
      const shipperNameOptions = mblScinList?.find(a => a.type === 4)?.scin
      return shipperNameOptions
    },
    ultimateConsigneeOptions() {
      const { mblScinList } = this.mblDetail
      const shipperNameOptions = mblScinList?.find(a => a.type === 5)?.scin
      return shipperNameOptions
    },
    importerOptions() {
      const { mblScinList } = this.mblDetail
      const shipperNameOptions = mblScinList?.find(a => a.type === 2)?.importer
      return shipperNameOptions
    },
    // addressDetail() {
    //   // const companyId = this.rowData.companyId
    //     const item = this.mblDetail?.clearence?.isf || {}
    //     const scinAddress = this.addressBookOptions[0]?.filter(a => a.type === 20 && (a.mblType === this.billType || a.mblType === null))
    //     const importerNameAddress = scinAddress?.find(a => a.companyName === item.importerNameAddress?.companyName)
    //     const manufacturerNameAddress = scinAddress?.find(a => a.companyName === item.manufacturerNameAddress?.companyName)
    //     const sellingNameAddress = scinAddress?.find(a => a.companyName === item.sellingNameAddress?.companyName)
    //     const buyerNameAddress = scinAddress?.find(a => a.companyName === item.buyerNameAddress?.companyName)
    //     const shipToPartyNameAddress = scinAddress?.find(a => a.companyName === item.shipToPartyNameAddress?.companyName)
    //     const consolidatorNameAddress = scinAddress?.find(a => a.companyName === item.consolidatorNameAddress?.companyName)
    //     const stuffingNameAddress = scinAddress?.find(a => a.companyName === item.stuffingNameAddress?.companyName)
    //     const consigneeNameAddress = scinAddress?.find(a => a.companyName === item.consigneeNameAddress?.companyName)
    //     return {
    //       importerNameAddress,
    //       manufacturerNameAddress,
    //       sellingNameAddress,
    //       buyerNameAddress,
    //       shipToPartyNameAddress,
    //       consolidatorNameAddress,
    //       stuffingNameAddress,
    //       consigneeNameAddress
    //     }
    // },
    mblHandlers() {
      const operator = this.mblDetail.mblHandlers?.filter(a => a.type === 0).map(a => a.userName).join(',') || '无'
      const customer = this.mblDetail.mblHandlers?.filter(a => a.type === 2).map(a => a.userName).join(',') || '无'
      const financer = this.mblDetail.mblHandlers?.filter(a => a.type === 1).map(a => a.userName).join(',') || '无'
      return {
        operator,
        customer,
        financer
      }
    }
    // pickUpAddress() {
    //   if (this.mblDetail.pickUpType === 1 &&
    //    (this.mblDetail.pickUp.sendWayItems[0].type === 2 ||
    //     this.mblDetail.pickUp.sendWayItems[0].type === 3)) {
    //     if (this.mblDetail.pickUp.sendWayItems[0].type === 2) {
    //       return this.AMZWarehouseList.find(a => a.code === this.mblDetail.pickUp.sendWayItems[0].code && a.type === 1)
    //     } else {
    //       return this.addressBookOptions.find(a => `${a.state} ${a.postalCode}` === this.mblDetail.pickUp.sendWayItems[0].code && a.type === 0)
    //     }
    //   } else {
    //     return {}
    //   }
    // }
    // sendWayAddress() {
    //   const addressArr = []
    //   this.tableData1.columns.forEach((item) => {
    //     if (item.type === 2) {
    //      const warehouse = this.AMZWarehouseList.find(a => a.code === item.code && a.type === 1)
    //      addressArr.push(warehouse || item)
    //     } else if (item.type === 3) {
    //      const warehouse = this.addressBookOptions.find(a => `${a.state} ${a.postalCode}` === item.code && a.type === 0)
    //      addressArr.push(warehouse || item)
    //     } else {
    //       addressArr.push({})
    //     }
    //   })
    //   console.log('addressArr', addressArr)
    //   return addressArr
    // }
  },
  watch: {
   async  drawer(val) {
      if (val) {
        this.size = 1340
        this.active = '0'
        this.orderActive = 0
        this.showTrack = false
        this.showIsf = false
        this.showOrderDetail = false
        this.pager2 = {
          pageIndex: 1,
          pageSize: 20
        }
        this.tableData1.columns = []
        this.tableData2.columns = []
        this.tableData3.columns = []
        this.tableData4.columns = []
        this.tableData5.columns = []
        this.tableData6.columns = []
        this.amsData = []
        await this.$store.dispatch('getAddressBookOptions', { type: -1, companyId: 0 })
        await this.getMblDetail()

        // 加载提单邮件
        this.getMBLEmail()
      }
    }
  },
  async mounted() {
    if (!this.addressDropOption || this.addressDropOption.length === 0) {
      this.$store.dispatch('getAddress')
    }
  },
  methods: {
    openEmailDialog(email) {
      this.emailDetail.visible = true
      this.emailDetail.currEmail = email
      console.log(email)
    },
    closeEmailDialog() {
      this.emailDetail.visible = false
    },
    async downLoad(file) {
      try {
        const res = await downLoadEmailFile({ guid: file.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    close() {
      this.$emit('close')
    },
    async getMBLEmail() {
      try {
        const result = await getMBLEmail(
          {
            mblId: this.rowData.id,
            start: this.emailForm.contractDate.length === 2 ? this.emailForm.contractDate[0] : undefined,
            end: this.emailForm.contractDate.length === 2 ? this.emailForm.contractDate[1] : undefined,
            search: this.emailForm.search ? this.emailForm.search : undefined
          }
          )
        if (result.success) {
          console.log('result.data', result.data)
          this.emailList = result.data
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (erroe) {
        console.error(erroe)
      }
    },
    async getMblDetail() {
      try {
        this.loading = true
        const result = await getMBLDetail({ mblId: this.rowData.id })
        if (result.success) {
          this.loading = false
          this.mblDetail = result.data
          this.tableData1.columns = result.data.pickUp?.sendWayItems
          this.tableData3.columns = result.data.clearence?.isf?.htsItems?.map(
            (a) => {
              return {
                hsCode: a.hsCode,
                nameEN: a.nameEN,
                originCountryCode: a.countryCode
              }
            }
          )
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (erroe) {
        console.error(erroe)
      }
    },
    async getList2(params) {
      try {
        params = {
          ...params,
          queryParam: {
            id: this.rowData.id
          }
        }
        const result = await getOrderDetailPages(params)
        if (result.success) {
          this.tableData2.columns = result.data.list
          this.tableData2.total = result.data.total
          this.orderStatusCollect = result.data.tabNumer
          this.orderTypeCollect = result.data.aggregatedData
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (erroe) {
        console.error(erroe)
      }
    },
    async getTrackDetail() {
      try {
        const result = await getMBLTrackList({ mblId: this.rowData.id })
        if (result.success) {
          this.trackList = result.data.map(a => {
            a.eventDate = /\d{4}-\d{1,2}-\d{1,2}[ ]\d{1,2}:\d{1,2}/g.exec(a.eventDate)[0]
            a.isOpen = true
            return a
          })
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (erroe) {
        console.error(erroe)
      }
    },
    handleClick() {
      this.active === '3' && this.getLists(this.pager2)
      this.active === '4' && this.getAbiquery()
      // this.active === ''
      this.$nextTick(() => {
        const viewDoc = document.querySelectorAll('.view')
        this.height = viewDoc[viewDoc.length - 1].offsetHeight
        if (this.active === '2' && viewDoc[viewDoc.length - 1].offsetHeight < 891) {
          this.height = 891
        }
      })
    },
    viewDetails(v) {
      if (v === 'track') {
        this.size = 520
        this.showTrack = true
        this.getTrackDetail()
      } else {
        this.showIsf = true
      }
    },
    back() {
      this.size = 1340
      this.showTrack = false
      this.showIsf = false
      this.showOrderDetail = false
    },
    detail(row) {
      this.size = 1076
      this.showOrderDetail = true
      this.orderId = row.masterOrderId
      this.getOrder()
      this.getPackageList(this.pager2)
    },
    changeType(type) {
      this.orderActive = type
      this.pager2 = {
        pageIndex: 1,
        pageSize: 20
      }
      type && this.getProductList(this.pager2)
      !type && this.getPackageList(this.pager2)
    },
    handlePageChange(pager) {
      this.pager2 = pager
      if (this.active === '3' && !this.showOrderDetail) {
        this.getList2(pager)
      }
      if (this.orderActive && this.showOrderDetail) {
        this.getProductList(pager)
      }
      if (!this.orderActive && this.showOrderDetail) {
        this.getPackageList(pager)
      }
    },
    async getOrder() {
      try {
        const res = await getOrderDetail({
          orderId: this.orderId
        })
        if (res.success) {
          this.order = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
        console.log(res)
      } catch (error) {
        console.error(error)
      }
    },
    async getPackageList(params) {
      try {
        params = {
          ...params,
          queryParam: {
            orderId: this.orderId
          }
        }
        const res = await getOrderDimensionPageList(params)
        if (res.success) {
          this.tableData4.columns = res.data.list
          this.tableData4.total = res.data.total
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getProductList(params) {
      try {
        params = {
          ...params,
          queryParam: {
            orderId: this.orderId
          }
        }
        const res = await getOrderProductPageList(params)
        if (res.success) {
          this.tableData5.columns = res.data.list
          this.tableData5.total = res.data.total
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    checkBillFile() {
      this.dialogVisible = true
    },
    formatterCountryCode(code) {
      if (this.addressDropOption && code) {
        const country = this.addressDropOption.find((a) => a.code === code)
        if (country) {
          return `${country.code}-${country.label}`
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    handleCopy(v) {
      const url = v
      const oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;

      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      oInput.remove()
    },
    isOepn(index) {
      this.$set(this.trackList[index], 'isOpen', !this.trackList[index].isOpen)
    },
    viewFile(guid) {
      guid && window.open(`/api/MBLFile/previewMBLFile?guid=${guid}`)
    },
    openUrl(menuCode = config.menuCode.GJCX) {
      this.$emit('close')
      const path = getRouteByCode(menuCode)
      // console.log(path, menuCode, btnCode)
      const params = { menuCode, mblNo: this.mblDetail.mblNo }
      this.$store.commit('SET_CONNNET', params)
      if (path !== this.$route.fullPath) {
        this.$router.push(path)
      }
    },
    async batchExport() {
      this.loading = true
      await derive('order/exportTrackingNumberMBL', 'get', { mblId: this.rowData.id })
      this.loading = false
    },
    async getLists() {
      const params = {
        number: this.rowData.mblNo
      }
      // this.billType === 0 &&
      //   (params = {
      //     carrierCode: this.rowData.mblNo.slice(0, 4),
      //     masterBLSerial: this.rowData.mblNo.slice(
      //       4,
      //       this.rowData.mblNo.length
      //     )
      //   })
      // this.billType === 1 &&
      //   ((params = {
      //     mawbPrefix: this.rowData.mblNo.slice(0, 3),
      //     mawbSerial: this.rowData.mblNo.slice(4, this.rowData.mblNo.length)
      //   }),
      //   this.reload(0))
        try {
          const result = await eFreightContainerEvents(params)
          // this.getContainer()
          if (result.success) {
            this.tableData6.columns = result.data.events.filter(a => a.trackTime)
            this.containerEvents = result.data
          } else {
            this.$message.error(result.errorMessage)
          }
        } catch (error) {
          console.error(error)
        }
    },
    async reload() {
      this.getAbiquery()
    },
    async getAbiquery() {
      try {
        const params = {
          mblNo: this.rowData.mblNo
        }
        this.loading = true
        const res = await abiquery(params)
        this.loading = false
        if (res.success) {
          this.amsOldData = res.data
          console.log(res)
          const arr = []
          if (res.data) {
            arr.push({
              number: res.data.masterBLNo,
              blType: 'M', // M 主单 H分单
              isf: res.data.isf,
              vesselName: res.data.vesselName,
              qty: res.data.quantity,
              voyageNumber: res.data.voyageNumber,
              lastRunTime: res.data.lastRunTime?.split(' ')[0],
              truckItems: []
            })
            res.data.houses?.forEach((item) => {
              arr.push({
                number: item.houseNo,
                blType: 'H',
                isf: !!item.isfMatched,
                vesselName: res.data.vesselName,
                qty: res.data.manifestQuantity,
                voyageNumber: res.data.voyageNumber,
                lastRunTime: res.data.lastRunTime?.split(' ')[0],
                inBondNumber: item.inBondNumber,
                truckItems: [],
                isRed: item.houseNo !== this.rowData.blNo.slice(4, this.rowData.blNo.length)
              })
            })
            res.data.events?.forEach((item) => {
              const data = arr.find(
                (a) => a.number.replace('-', '') === item.blNo && a.blType === item.blType
              )
              if (item) {
                data?.truckItems?.push({
                  dispositionCode: item.dispositionCode,
                  dispositionDesc: item.dispositionDesc,
                  manifestQuantity: item.manifestQuantity,
                  eventDate: item.eventDate
                })
              }
            })
            this.amsData = arr
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async reloadshipPart() {
      try {
        const res = await iTraceTerminal({ number: this.rowData.mblNo })
        if (res.success) {
          this.$message.success('刷新成功')
          // this.containerEvents = res.data
          this.getLists()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async reloadship() {
      try {
        const res = await syncAbiTrack(this.amsOldData)
        if (res.success) {
          this.$message.success('同步成功')
          setTimeout(() => {
            this.getAbiquery()
          }, 1000)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async reSub() {
      try {
        const res = await reSubscribeClearanceTrack({ mblId: this.rowData.id })
        if (res.success) {
          this.$message.success('重新订阅成功')
          setTimeout(() => {
            this.getAbiquery()
          }, 1000)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.closeIcon {
  font-size: 20px;
  cursor: pointer;
}
.view {
  width: 100%;
  height: 100%;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  overflow-y: hidden;
  &:deep(.fTable) {
    .fp-cell {
      border: 0;
    }
  }

  label {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    background: #e9ecf3;
    border-radius: 4px;
    font-size: 14px;
    color: #142e79;
  }
  .panelActive1 {
    label {
      width: 140px;
      margin-right: 8px;
    }
  }
  .panelActive2,
  .panelActive3 {
    label {
      width: 120px;
      margin-right: 8px;
    }
  }
  .panelActive4 {
    label {
      width: 80px;
      margin-right: 10px;
    }
    .derive {
      width: 100px;
      height: 30px;
      background:  rgb(18,88,188);
      border-radius: 2px 2px 2px 2px;
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      cursor: pointer;
      margin-bottom: 10px;
      transform: translateX(540%);
    }
  }
  .orderActive {
    label {
      width: 100px;
      height: 30px;
      background: #FFFFFF;
      margin-right: 15px;
    }
  }
  .data {
    width: calc(100% - 80px);
    height: 400px;
    margin: 16px auto;
  }
  .data2 {
    width: 100%;
    height: 400px;
    margin: 15px auto;
  }
  .table-opt {
    display: flex;
    justify-content: space-around;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .tag {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #F7F7F7;
    padding-right: 20px;
    box-sizing: border-box;
    &:deep(.el-tabs__header) {
      margin: 15px 0;
    }
    &:deep(.el-tabs--card > .el-tabs__header) {
      border-bottom: 0;
    }
    &:deep(.el-tabs__nav) {
      border: 0;
    }
    &:deep(.el-tabs__item) {
      height: 24px;
      line-height: 24px;
      border: 0;
    }
    &:deep(.el-tabs__item.is-active) {
      color:  rgb(18,88,188);
    }
  }
  .panle-container {
    width: 100%;
    height: auto;
    border-radius: 6px 6px 6px 6px;
    .table-header {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #F7F7F7;
      border-radius: 4px 4px 0px 0px;
      border: 1px solid #EEEEEE;
      border-bottom: 0;
      box-sizing: border-box;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .markbox {
      display: inline-block;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      .mark-label {
        width: auto;
        height: 24px;
        border-radius: 4px 4px 4px 4px;
        margin-right: 4px;
        padding: 0 6px;
      }
      .mark-info {
        color: #333333;
      }
      .green {
        color: #35BA83;
        background: rgba(53, 186, 131, .1);
      }
      .red {
        color: #FE453D;
        background: rgba(254, 69, 61, .1);
      }
      & + .markbox {
        margin-left: 24px;
      }
    }
    .lable {
      display: block;
      background: #F7F7F7;
      padding: 0 5px;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      text-align: left;
      position: relative;
      height: 20px;
      & + .lable {
        margin-left: 5px
      }
      .sufix {
        position: absolute;
        right: 5px;
        color: #999999;
      }
    }
  }
  .panel {
    width: 100%;
    height: calc(100vh - 124px);
    margin: 20px auto 0;
    padding: 0 40px 20px;
    box-sizing: border-box;
    overflow-y: auto;
    .panel-title {
      position: relative;
      display: flex;
      align-items: center;
      height: 24px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 17px;
      svg {
        margin-right: 8px;
      }
      .panel-titleInfo {
        display: flex;
        align-items: center;
        & > div:first-child {
          display: flex;
          align-items: center;
        }
        .roughly {
          display: flex;
          margin-left: 15px;
          .roughly-item {
            display: flex;
            align-items: center;
            & > span:first-child {
              width: 40px;
              height: 24px;
              background: rgba(38, 152, 245, .1);
              border-radius: 4px 4px 4px 4px;
              font-size: 12px;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              color:  rgb(18,88,188);
            }
            & > span:last-child {
              margin-left: 5px;
            }
            & + .roughly-item {
              margin-left: 15px;
            }
          }
        }
      }
      .open {
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 24px;
        background: rgba(37, 151, 244, .1);
        border-radius: 4px 4px 4px 4px;
        font-size: 12px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color:  rgb(18,88,188);
        cursor: pointer;
      }
    }
  }
  .panel2 {
    margin-bottom: 12px;
  }
  .panel3 {
    width: 100%;
  }
  .typeName {
    display: flex;
    justify-content: space-between;
  }
  .estimatedDeliveryTime {
    position: absolute;
    top: 0;
    left: 0;
    width: 156px;
    height: 20px;
    background: #EBF9F3;
    border-radius: 0px 0px 6px 0px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #35BA83;
  }
  .field,
  .field2 {
    width: 100%;
    height: auto;
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:deep(.el-row) {
    .el-col:nth-child(n + 4) {
      margin-top: 8px;
    }
  }
  .field {
    p {
      flex: 1;
      height: 30px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 10px;
      box-sizing: border-box;
      line-height: 30px;
    }
  }
  .field-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: calc(100% - 164px);
    min-height: 50px;
    height: auto;
    .field-c_top {
      display: flex;
      width: 100px;
      margin-bottom: 4px;
      .field3 {
        display: flex;
        align-items: center;
        margin-right: 16px;
        & > span:first-child {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 56px;
          height: 24px;
          border-radius: 4px 4px 4px 4px;
          background: rgba(53, 186, 131, 0.1);
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #35ba83;
          margin-right: 4px;
        }
        & > span:last-child {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
      }
    }
    .field-c_bottom {
      width: 100%;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      word-break: break-all;
      white-space: break-spaces;
      p {
        font-size: 12px;
        height: auto;
        line-height: normal;
        text-overflow: clip;
        word-wrap: break-word;
        word-break: break-all;
        white-space: break-spaces;
      }
    }
  }
  .field2 {
    align-items: center;
    p {
      flex: 1;
      height: 32px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 6px;
      box-sizing: border-box;
    }
  }
  .panle-container2 {
    width: calc(100% - 48px);
    height: auto;
    padding: 24px;
    border-radius: 6px 6px 6px 6px;
    background: #ffffff;
    border: 1px solid #f2f7ff;
    margin-bottom: 32px;
    label {
      width: 100px;
    }
  }
  .panle-container3 {
    width: calc(100% - 40px);
    height: auto;
    padding: 20px 15px;
    border-radius: 4px 4px 4px 4px;
    background: #FBFBFB;
    margin-bottom: 20px;
    .panle-title {
      height: 21px;
      font-size: 16px;
      font-weight: 400;
      color:  rgb(18,88,188);
      line-height: 21px;
      margin-left: 10px;
      margin-bottom: 20px;
    }
    p {
      display: flex;
      align-items: center;
      width: auto;
      height: 32px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .label {
      width: 40px;
      height: 24px;
      background: rgba(35, 149, 243, .1);
      border-radius: 4px 4px 4px 4px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color:  rgb(18,88,188);
      margin-right: 5px;
    }
  }
  .check_file {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 104px;
    height: 24px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
    i {
      font-size: 14px;
      margin-right: 4px;
    }
  }
  .bill-status {
    height: 24px;
    text-align: center;
    background: rgba(254, 69, 61, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #fe453d;
    padding: 3px 10px;
    box-sizing: border-box;
  }
  .status {
    display: inline-block;
    width: 64px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background: rgba(53, 186, 131, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #35ba83;
  }
  .order-status {
    display: inline-block;
    width: auto;
    height: 26px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 26px;
    color: #35ba83;
    background-color: rgba(53, 186, 131, 0.1);
    padding: 0 12px;
    border-radius: 4px 4px 4px 4px;
  }
  .type {
    display: inline-block;
    padding: 0 6px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 4px 4px 4px 4px;
    margin-right: 4px;
  }
  .type2 {
    display: flex;
    height: 40px;
    border-radius: 4px;
    width: 410px;
    background: #F7F7F7;
    border: 1px solid #EEEEEE;
    margin: 40px auto 0;
    padding: 5px;
    box-sizing: border-box;
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      cursor: pointer;
    }
    .active {
      background: #FFFFFF;
      box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.05);
      color:  rgb(18,88,188);
    }
  }
  .type_text {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
  }
  .panel-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid  rgb(18,88,188);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    cursor: pointer;
    & + .panel-btn  {
      margin-left: 20px;
    }
    img {
      margin-right: 8px;
    }
  }
  .panel-btn-content {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 40px auto 0;
    height: 80px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.16);
  }
  .opt-btn {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    border: 1px solid  rgb(18,88,188);
    padding: 0 4px;
    cursor: pointer;
    border-radius: 4px;
    img {
      margin-right: 4px;
    }
  }
}
.amsList {
  width: 100%;
  height: calc(100% - 34px);
  .list {
    width: 100%;
    height: calc(50% - 6px);
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #eeeeee;
    & + .list {
      margin-top: 8px;
    }
    .list-top {
      width: 100%;
      height: 55px;
      background: #f7f7f7;
      text-indent: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 55px;
      .label + .label {
        margin-left: 24px;
      }
      .value {
        color: #666666;
      }
      .Master {
        width: 100px;
        height: 23px;
        background: #e8f4ff;
        border-radius: 4px 4px 4px 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color:  rgb(18,88,188);
        line-height: 23px;
        text-align: center;
        display: inline-block;
        text-indent: 0;
      }
      .House {
        width: 100px;
        height: 23px;
        background: #f4ecfe;
        border-radius: 4px 4px 4px 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #a55af8;
        line-height: 23px;
        text-align: center;
        display: inline-block;
        text-indent: 0;
      }
    }
    .list-middle {
      width: calc(100% - 16px);
      padding: 0 16px;
      height: calc(100% - 55px);
      max-height: calc(100% - 55px);
      overflow: hidden;
      overflow-y: auto;
      div {
        width: 100%;
        height: 16px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 16px;
        margin-top: 14px;
      }
      .icon {
        display: inline-block;
        width: 44px;
        height: 20px;
        background: #EDFFF8;
        border-radius: 4px 4px 4px 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #35BA83;
        line-height: 20px;
        text-align: center;
        vertical-align: 4px;
      }
      .desc {
        width: 60%;
        max-width: 60%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
      .quantity {
        width: calc(20% - 22px );
        display: inline-block;
      }
    }
  }
}
  .amsList {
    width: 100%;
    height: calc(100% - 34px);
    .list {
      width: 100%;
      height: calc(50% - 6px);
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #eeeeee;
      & + .list {
        margin-top: 8px;
      }
      .list-top {
        width: 100%;
        height: 55px;
        background: #f7f7f7;
        text-indent: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 55px;
        .label + .label {
          margin-left: 24px;
        }
        .value {
          color: #666666;
        }
        .Master {
          width: 100px;
          height: 23px;
          background: #e8f4ff;
          border-radius: 4px 4px 4px 4px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color:  rgb(18,88,188);
          line-height: 23px;
          text-align: center;
          display: inline-block;
          text-indent: 0;
        }
        .House {
          width: 100px;
          height: 23px;
          background: #f4ecfe;
          border-radius: 4px 4px 4px 4px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #a55af8;
          line-height: 23px;
          text-align: center;
          display: inline-block;
          text-indent: 0;
        }
      }
      .list-middle {
        width: calc(100% - 16px);
        padding: 0 16px;
        height: calc(100% - 55px);
        max-height: calc(100% - 55px);
        overflow: hidden;
        overflow-y: auto;
        div {
          width: 100%;
          height: 16px;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          line-height: 16px;
          margin-top: 14px;
        }
        .icon {
          display: inline-block;
          width: 44px;
          height: 20px;
          background: #EDFFF8;
          border-radius: 4px 4px 4px 4px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #35BA83;
          line-height: 20px;
          text-align: center;
          vertical-align: 4px;
        }
        .desc {
          width: 60%;
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        .quantity {
          width: calc(20% - 22px );
          display: inline-block;
        }
      }
    }
  }
.back {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #f2f7ff;
  padding-left: 12px;
  padding-right: 20px;
  box-sizing: border-box;
  .title {
    display: flex;
  }
  .before {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    cursor: pointer;
  }
  .current {
    display: flex;
    align-items: center;
    margin-left: 10px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  span {
    margin-left: 8px;
  }
}
.log-body {
  width: 100%;
  height: calc(100vh - 120px);
  margin: 20px auto 0;
  padding: 0 20px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .isf_info {
    width: 100%;
    margin-bottom: 24px;
    &:deep(.el-row + .el-row) {
      margin-top: 0;
    }
    .row-item {
      display: flex;
      width: 100%;
      height: auto;
      margin-bottom: 8px;
    }
    .item-label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      background: #F7F7F7;
      border-radius: 4px 4px 4px 4px;
      min-height: 30px;
      text-align: center;
      line-height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-right: 20px;
    }
    .item-data {
      display: flex;
      align-items: center;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      height: auto;
      min-height: 30px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .address {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      flex: 1;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      height: auto;
      min-height: 80px;
      .conpanyName {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        & span:first-child {
          display: inline-block;
          width: 48px;
          height: 24px;
          line-height: 24px;
          background: rgba(53, 186, 131, 0.1);
          border-radius: 4px 4px 4px 4px;
          color: #35ba83;
          text-align: center;
        }
        & span:last-child {
          color: #333333;
          margin-left: 5px;
        }
        & + .conpanyName {
          margin-left: 5px;
        }
      }
      p {
        color: #666666;
        word-wrap: break-word;
        word-break: break-all;
        white-space: break-spaces;
      }
    }
  }
  .track-num {
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #F7F7F7;
    border-radius: 6px 6px 6px 6px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    .number {
      color:  rgb(18,88,188);
    }
  }
  .track-other {
    display: flex;
    width: 100%;
    height: 80px;
    margin-top: 10px;
    .country {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 292px;
      height: 100%;
      background: #F7F7F7;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      margin-right: 10px;
      font-size: 18px;
      font-weight: bold;
      color:  rgb(18,88,188);
      img {
        margin: 0 10px;
      }
      .country-code {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 120px;
        & span:last-child {
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
    .navication {
      width: 200px;
      height: 100%;
      background: #F7F7F7;
      color: #333333;
      border-radius: 6px 6px 6px 6px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      span {
        color:  rgb(18,88,188);
      }
    }
  }
  .track-step {
    width: 100%;
    height: auto;
    min-height: 438px;
    background: #FBFBFB;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    margin-top: 10px;
    padding: 22px 0 0 20px;
    box-sizing: border-box;
    .step-item {
      position: relative;
      height: auto;
      color: #999999;
      .step-title {
        display: flex;
        align-items: center;
        position: relative;
        height: 16px;
        .dot {
          display: flex;
          justify-content: center;
          width: 12px;
        }
        .step-dot {
          width: 8px;
          height: 8px;
          background: #cdcdcd;
          border-radius: 50px;
        }
        .blue-dot {
          width: 12px;
          height: 12px;
          background:  rgb(18,88,188);
        }
        .check-dot {
          width: 12px;
          height: 12px;
          background: #FF7444;
          z-index: 1;
        }
        .step-time {
          position: absolute;
          left: 26px;
          width: calc(100% - 55px);
          font-size: 12px;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .step-info {
        font-size: 14px;
        font-weight: bold;
        color: #999999;
        line-height: 19px;
        margin: 8px 0 0 26px;
        padding-bottom: 24px;
        box-sizing: border-box;
        .step-detail {
          width: 414px;
          height: 78px;
          background: rgba(255, 255, 255, .8);
          border-radius: 6px 6px 6px 6px;
          margin-top: 8px;
          padding: 10px;
          border: 1px solid #EEEEEE;
          box-sizing: border-box;
        }
        .el-row {
          margin-top: 5px;
        }
        .step-detail_item {
          display: flex;
          align-items: center;
          height: 16px;
          font-size: 12px;
          font-family: Microsoft YaHei UI-Light, Microsoft YaHei UI;
          font-weight: 300;
          color: #999999;
        }
        .detail-label1 {
          display: inline-block;
          width: 48px;
          margin-right: 10px;
        }
        .detail-label2 {
          width: 26px;
          display: inline-block;
          margin-right: 10px;
        }
        .detail-info {
          color: #333333;
          font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
          font-weight: 400;
        }
        .viewFile {
          width: 34px;
          height: 16px;
          background:  rgb(18,88,188);
          border-radius: 8px 8px 8px 8px;
          color: #F7F7F7;
          font-size: 12px;
          margin-left: 8px;
          cursor: pointer;
        }
      }
      .step-line {
        position: absolute;
        top: 10px;
        left: 6px;
        height: 100%;
        border-left: 1px solid #cdcdcd;
      }
      .blue {
        color:  rgb(18,88,188);
      }
      .check {
        color: #FF7444;
      }
      .blue-line {
        border-left: 1px dashed  rgb(18,88,188);
      }
      .arrow {
        position: absolute;
        right: 24px;
        top: 0;
        font-size: large;
        color:  rgb(18,88,188);
        cursor: pointer;
      }
    }
  }
}
.address-content {
  width: 460px;
  min-height: 140px;
  margin: 8px;;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #DBE4F2;
  .address-lable {
    width: 460px;
    height: 40px;
    background: #F8FBFF;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;
    border-bottom: 1px solid #DAE5FF;
    font-size: 12px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #25396F;
    line-height: 40px;
    text-indent: 16px;
  }
  .address-value {
    width: 428px;
    padding: 16px;
    .lable {
      display: inline-block;
      padding: 0 10px;
      height: 20px;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #35BA83;
      line-height: 20px;
      background: rgba(53, 186, 131, .1);
    }
    .value {
      width: auto;
      margin-left: 4px;
      height: 20px;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #25396F;
      line-height: 20px;
    }
    .address-detail {
      width: 100%;
      min-height: 20px;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #7C8DB5;
      line-height: 20px;
    }
  }
}
</style>
<style lang="less">
.el-popper {
  .view-detail {
    width: 100%;
    max-height: 240px;
    height: auto;
    overflow-y: scroll;
  }
  .eventItems {
    width: 100%;
    padding: 8px;
    background: #f8fbff;
    border-radius: 6px 6px 6px 6px;
    box-sizing: border-box;
  }
}
.remarks-box {
  width: 100%;
  height: 240px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  overflow: hidden;
  .remarks-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    background: #F7F7F7;
    border-bottom: 1px solid #EEEEEE;
    box-sizing: border-box;
    padding: 0 20px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    & span:nth-child(2) {
      color:  rgb(18,88,188);
      cursor: pointer;
    }
  }
  .remarks-body {
    width: 100%;
    height: calc(100% - 40px);
    padding: 15px 20px;
    box-sizing: border-box;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    overflow-y: auto;
  }
}

.email-record{
  display: flex;
  flex-direction: column;
}
.mbl-info-search{
  display: flex;
  margin-bottom:20px;
  .group-box{
    display: flex;
    margin-left: 20px;
    border-radius: 5px;

    .input-search {
        width:230px;

        ::v-deep .el-input {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        ::v-deep .el-input-group__append {
          background-color: transparent;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          padding: 0 10px;
        }

        ::v-deep .el-input__inner {
          height: 30px;
          line-height: 30px;
        }
      }
  }
}

.mbl-info-section{
  overflow: auto;
  flex:1;
}

.mbl-info {
  padding: 12px 20px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  font-size: 13px;
  margin-bottom: 15px;
  .info-row {
    margin-bottom: 6px;
    display: flex;
    align-items: flex-start;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .info-label {
    color: #333;
    flex-shrink: 0;
    &.ml-20 {
      margin-left: 20px;
    }
  }
  .info-value {
    color: #666;
    font-size: 12px;
  }
  .attachments-row {
    align-items: center;
  }
  .attachment-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .attachment-tag {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 3px 8px;
      background: #f9f9f9;
      border-radius: 4px;
      font-size: 12px;
      color: #666;
      cursor: pointer;
      .el-icon-download {
        color: #1890ff;
        cursor: pointer;
      }
    }
  }

  .email-item-title{
    font-weight:bold;
    margin-bottom:15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

</style>
